import { render, staticRenderFns } from "./ShoppingCartItem.vue?vue&type=template&id=1fe16e45&scoped=true&"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartItem.vue?vue&type=style&index=0&id=1fe16e45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe16e45",
  null
  
)

export default component.exports